'use strict'

export default class BaseDashboard {

    constructor ($rootScope, $http, $scope, $state) {
        this.$http = $http
        this.$scope = $scope
        this.$state = $state
        this.showOnlyGroups = false
        this.userGroups = []

        this.groupsEnabled = false
        this.date = new Date()

        this.fetch(this.date)
        this.fetchGroups()
    }

    fetch (date) {
        this.date = date
        this.$http.get('/dashboard/details/' + moment(date).format('YYYY-MM-DD')).then(result => {
            this.groupsEnabled = result.data.groupsEnabled

            if (!this.showOnlyGroups) {
                this.applyNewData(result.data.days)
            } else {
                result.data.days.map(day => {
                    let broadcastArray = day.broadcasts

                    for (let i = broadcastArray.length - 1; i >= 0; --i) {
                        if (!this.checkGroup(broadcastArray[i].group_id)) {
                            broadcastArray.splice(i, 1)
                        }
                    }
                })
                this.applyNewData(result.data.days)
            }
        })
    }

    fetchGroups () {
        this.$http.get('/get-user-groups/').then(result => {
            this.userGroups = result.data
        })
    }

    checkGroup (group_id) {
        return this.userGroups.some(function (el) {
            return el.id === group_id
        })
    }

    applyNewData (data) {}

    previousDay () {
        this.fetch(new Date(this.date.setDate(this.date.getDate() - 1)))
    }

    currentDay () {
        this.fetch(new Date())
    }

    nextDay () {
        this.fetch(new Date(this.date.setDate(this.date.getDate() + 1)))
    }

    pickDate () {
        this.fetch(new Date(this.date.setDate(this.date.getDate())))
    }

    broadcastHasItems (broadcast) {
        let itemCount = 0

        if (broadcast.blocks) {
            broadcast.blocks.forEach((block) => {
                block.items.forEach(item => itemCount++)
            })
        }

        return itemCount > 0
    }

    goToItem (broadcast, item) {
        if (broadcast.masterstation_id) {
            this.$state.go('rundown.edit', {
                broadcast: broadcast.slavebroadcast_id,
                program: broadcast.program_id,
                externalBroadcastId: broadcast.id,
                itemId: item.id,
                stationId: broadcast.masterstation_id,
                blockId: item.block_id,
                type: 'block',
            })
        } else {
            this.$state.go('rundown.edit', {
                broadcast: broadcast.id,
                program: broadcast.program_id,
                itemId: item.id,
                blockId: item.block_id,
                type: 'block',
            })
        }
    }

}

